module.exports = __webpack_public_path__ + "static/media/avatar.4f427376.png";